/* ============================================================
   SBD mega menu — rebuilds Impulse's megamenu into the parent site's
   layout: a Men/Women toggle, three link columns, a row of trust
   badges beneath them, and a promo tile in a fixed right-hand column.

   sbdapparel.com renders

     .sbd-nav__dropdown-inner        grid, 1fr 300px
       .sbd-nav__gender-toggle       full width, above the grid
       .sbd-nav__gender-panel        one per gender
         .sbd-nav__left-zone
           .sbd-nav__columns         grid, repeat(3, 1fr)
           .sbd-nav__icon-strip
         .sbd-nav__featured-image

   Impulse gives us only .megamenu__inner > .megamenu__nav > .megamenu__column,
   with no panels and no promo slot, so this script reshapes it to

     .megamenu__inner
       .sbd-nav__tabs                (only when both genders are present)
       .sbd-nav__body                grid, 1fr 300px
         .sbd-nav__left
           .megamenu__nav            grid, repeat(3, 1fr)
           .sbd-nav__icons
         .sbd-nav__figure

   Columns are grouped by gender from their heading text and shown a
   group at a time, since Impulse cannot render one panel per gender.

   Content comes from window.SBD_NAV, set in snippets/sbd-nav-assets.liquid.

   Degrades safely. With JS off, or with no SBD_NAV, every column renders
   as an ordinary Impulse megamenu column and nothing is lost but the
   badges, the promo tile and the toggle.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.SBD_NAV || {};

  function el(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  /* The four trust badges. Decorative, so they carry empty alt text. */
  function buildIcons() {
    if (!CFG.icons || !CFG.icons.length) return null;
    var strip = el('div', 'sbd-nav__icons');
    CFG.icons.forEach(function (src) {
      var item = el('div', 'sbd-nav__icon');
      var img = el('img');
      img.src = src;
      img.alt = '';
      img.width = 96;
      img.height = 96;
      img.loading = 'lazy';
      item.appendChild(img);
      strip.appendChild(item);
    });
    return strip;
  }

  /* The right-hand promo tile. Returns the element plus a setter so the
     tile can follow the Men/Women toggle. */
  function buildFigure(config) {
    if (!config) return null;

    var figure = el('div', 'sbd-nav__figure');
    var link = el('a', 'sbd-nav__figure-link');
    var img = el('img');
    var label = el('span', 'sbd-nav__figure-label');

    img.alt = '';
    img.loading = 'lazy';
    link.appendChild(img);
    link.appendChild(label);
    figure.appendChild(link);

    function apply(data) {
      if (!data || !data.image) return;
      img.src = data.image;
      link.href = data.url || '#';
      label.textContent = data.label || '';
    }

    return { node: figure, apply: apply };
  }

  /* "Men's" -> By Product, "Men's by Use Case" -> By Use Case, and so on.
     Driven by keywords rather than exact titles so renaming a menu item
     does not silently break the heading. */
  function headingFor(text) {
    if (/use case/.test(text)) return 'By Use Case';
    if (/collection/.test(text)) return 'Our Collections';
    return 'By Product';
  }

  function decorate(nav) {
    if (!nav || nav.dataset.sbdReady) return;
    var columns = Array.prototype.slice.call(nav.querySelectorAll('.megamenu__column'));
    if (!columns.length) return;

    var inner = nav.parentNode;
    if (!inner) return;

    /* Which top-level menu is this? Used to pick the promo tile.
       The trigger is a <summary class="site-nav__link">, not an <a> — a
       megamenu item is always a <details>, so do not match on the tag. */
    var item = nav.closest ? nav.closest('.site-nav__item') : null;
    var trigger = item ? item.querySelector('.site-nav__link') : null;
    var key = trigger ? trigger.textContent.trim().toLowerCase() : '';
    var figureConfig = (CFG.figures || {})[key];

    /* Mark "All ..." links so they pick up the red underlined treatment. */
    columns.forEach(function (col) {
      col.querySelectorAll('a.site-nav__dropdown-link').forEach(function (a) {
        if (a.classList.contains('site-nav__dropdown-link--top-level')) return;
        if (/^all\b/i.test(a.textContent.trim())) a.classList.add('sbd-nav__all');
      });
    });

    /* Group the columns by gender and rewrite their headings. */
    var groups = { men: [], women: [] };

    columns.forEach(function (col) {
      var heading = col.querySelector('.site-nav__dropdown-link--top-level');
      if (!heading) return;
      var text = heading.textContent.trim().toLowerCase();
      var gender = /women/.test(text) ? 'women' : (/\bmen/.test(text) ? 'men' : null);
      if (!gender) return;

      groups[gender].push(col);
      heading.textContent = headingFor(text);

      var tag = el('span', 'sbd-nav__eyebrow');
      tag.textContent = gender === 'women' ? '(Women)' : '(Men)';
      heading.appendChild(tag);
    });

    /* Reshape into left zone + promo column. */
    var body = el('div', 'sbd-nav__body');
    var left = el('div', 'sbd-nav__left');
    inner.insertBefore(body, nav);
    left.appendChild(nav);
    body.appendChild(left);

    var icons = buildIcons();
    if (icons) left.appendChild(icons);

    var gendered = groups.men.length && groups.women.length;
    var figure = buildFigure(figureConfig);

    if (figure) {
      body.appendChild(figure.node);
      if (!gendered) figure.apply(figureConfig);
    }

    if (!gendered) {
      nav.dataset.sbdReady = '1';
      return;
    }

    /* Men / Women toggle, full width above the grid. */
    var tabs = el('div', 'sbd-nav__tabs');
    tabs.setAttribute('role', 'tablist');

    function select(which) {
      groups.men.forEach(function (c) { c.toggleAttribute('data-sbd-hidden', which !== 'men'); });
      groups.women.forEach(function (c) { c.toggleAttribute('data-sbd-hidden', which !== 'women'); });
      tabs.querySelectorAll('.sbd-nav__tab').forEach(function (b) {
        b.setAttribute('aria-selected', String(b.dataset.sbdGender === which));
      });
      if (figure && figureConfig) figure.apply(figureConfig[which]);
    }

    [['men', 'Men'], ['women', 'Women']].forEach(function (pair) {
      var button = el('button', 'sbd-nav__tab');
      button.type = 'button';
      button.dataset.sbdGender = pair[0];
      button.textContent = pair[1];
      button.setAttribute('role', 'tab');
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        select(pair[0]);
      });
      tabs.appendChild(button);
    });

    inner.insertBefore(tabs, body);
    select('men');
    nav.dataset.sbdReady = '1';
  }

  function init() {
    document.querySelectorAll('.megamenu__nav').forEach(decorate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
